module.exports = __webpack_public_path__ + "img/tiktok.4c009f8f.svg";